module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emailsAutocomplete.label":"Emails","emailsAutocomplete.createPrompt":"Click to add","emailsAutocomplete.notValidEmail":"Not a valid email","emailsAutocomplete.pleaseTypePrompt":"Type to enter an email"}}')
  delete Component.options._Ctor
}
